<template>
    <div class="row pad header-fixed site-header">

        <div class="col s9m offset-sm" style="">BIOMEDIA <span style="font-size:80%;">PIATTAFORMA ABSTRACT</span></div>
        <div class="col s1m yo-align-right"  style="">
            <img src="../assets/ico-eng.png" @click="changeLang('en')" v-if="$teras.language=='it'"/>
            <img src="../assets/ico-ita.png" @click="changeLang('it')" v-if="$teras.language=='en'"/>
            
<!--
            <a href="http://www.sip.it" target="blank">SIP.IT</a>
            <router-link to="/inside/contatti/segreteria-organizzativa">CONTATTI</router-link>
            <router-link to="/home">HOME</router-link>
    -->          
        </div>

    </div>
</template>

<script>

export default {
  name: 'site-header',
  watch: {
    '$teras.language':  'terasChange'
  },
  methods: {
    terasChange(){
      console.log(this.$teras.language)
    },
    changeLang(lang){
      this.$teras.language=lang
      this.$teras.lang= this.$teras[ this.$teras.language]
    }
  }  
}
</script>
<style>
.site-header{
    background: #007296 !important;
    color:#ffffff;
}.site-header .col{
    height: 40px;
    line-height:40px;

}.site-header a{
    color:#ffffff;
    line-height: 1.6rem;
    font-size: 1.6rem;
    float:right;
    padding: 0 20px;
    margin:10px 0 0 0;
    border-left:1px solid #fff;
}.site-header img{
    height:24px;
    margin:8px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Site-header.vue?4e07c230